// Component Imports
import HelpAndFeedBack from "../Components/HelpAndFeedBack"
import FAQ from "../Components/FAQ"

// Main Component
const FeedBack = () => {
  // Rendered Component
  return (
    <div>
      <HelpAndFeedBack/>
      <FAQ /> 
    </div>
  )
}

export default FeedBack
